// noinspection DuplicatedCode

import React, { useEffect, useState } from 'react';
import { Button, Form, FormGroup, Table } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { Link } from 'react-router-dom';
import Contents from 'components/Layout/Contents';
import { Input } from 'components/Forms';
import Alert from 'components/Alert/Alert';
import CompetencyService from 'api/CompetencyService';
import './SpecialtyForms.scss';

export default function AddCompetency() {
  const [savedSuccessfully, setSavedSuccessfully] = useState(null);
  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      referenceId: '',
      name: '',
      listType: 0,
    },
  });
  const mutation = useMutation((payload) => CompetencyService.add(payload), {
    onSuccess: (response) => {
      if (response.data) {
        setValue('referenceId', '');
        setValue('name', '');
        setSavedSuccessfully(response.data);
        window.history.pushState(
          response.data,
          '',
          `${window.location.href}?saved=${response.data.id}`
        );
      }
    },
  });
  const onSubmit = (formData) => {
    mutation.mutate(formData);
  };
  const addNewSpecialtyAgain = () => {
    mutation.reset();
    setSavedSuccessfully(null);
    window.history.pushState(null, '', '/admin/competencies/add');
  };

  const frmAddSpecialty = document.getElementById('frmAddSpecialty');
  useEffect(() => {
    window.history.pushState(null, '', '/admin/competencies/add');
  }, []);

  if (savedSuccessfully && mutation.isSuccess) {
    return (
      <div className="saved-details">
        <Alert variant="success" title="Processing">
          New specialty added.
        </Alert>
        <div className="d-block mt-4">
          <Table>
            <tbody>
              <tr>
                <td style={{ width: '210px' }} className="text-muted">
                  ID
                </td>
                <td>{savedSuccessfully.referenceId}</td>
              </tr>
              <tr>
                <td className="text-muted">Name</td>
                <td>{savedSuccessfully.name}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="3" className="border-0">
                  <div className="d-flex py-3">
                    <Link to="/competencies">Return to Specialties list</Link>
                    <Button
                      variant="primary"
                      className="btn btn-primary ms-auto"
                      onClick={addNewSpecialtyAgain}
                    >
                      Add another specialty
                    </Button>
                  </div>
                </td>
              </tr>
            </tfoot>
          </Table>
        </div>
      </div>
    );
  }

  return (
    <Contents title="Add Specialty">
      <div className="add-specialty">
        {mutation.isLoading && (
          <Alert
            variant="info"
            title="Processing"
            iconProps={{ spin: true, pulse: true }}
          >
            Adding specialty...
          </Alert>
        )}
        {mutation.isError && (
          <Alert variant="danger" title="Error">
            An error occurred: {mutation.error.message}
          </Alert>
        )}
        {mutation.isSuccess && (
          <Alert variant="success" title="Processing">
            New competency added.
          </Alert>
        )}
        {
          // eslint-disable-next-line react/prop-types
          mutation.isSuccess && frmAddSpecialty.reset()
        }
        <Form onSubmit={handleSubmit(onSubmit)} id="frmAddSpecialty">
          <FormGroup>
            <Input
              label="ID"
              control={control}
              name="referenceId"
              placeholder="ID"
              rules={{ required: true }}
              disabled={mutation.isLoading}
            />
          </FormGroup>
          <FormGroup>
            <Input
              label="Name"
              control={control}
              name="name"
              placeholder="Name"
              rules={{ required: true }}
              disabled={mutation.isLoading}
            />
          </FormGroup>
          <FormGroup>
            <div className="mt-3 d-block">
              <Button
                variant="primary"
                className="btn-pmi"
                type="submit"
                disabled={mutation.isLoading}
              >
                Save
              </Button>
              <Link
                as={Button}
                className="d-inline-block ms-3"
                to="/competencies"
              >
                Cancel
              </Link>
            </div>
          </FormGroup>
        </Form>
      </div>
    </Contents>
  );
}
